import { LightShowOperation } from './lightshow-operation';
import { LightshowState } from '../lightshow-state';
import { FlashTypes } from '../operation-types';

export class TorchOperation extends LightShowOperation {
  private ignoreOverlap: boolean;

  constructor(position: number, duration: number, sectionList: string[], ignoreOverlap = false, uniqueId = Math.random().toString(36).slice(-5) ) {
    super();
    this.position = position;
    this.duration = duration;
    this.color = 'white';
    this.flashType = FlashTypes.torchOn;
    this.timelineColor = 'blue';
    this.uniqueId = uniqueId;
    this.ignoreOverlap = ignoreOverlap;
    this.sectionList = sectionList;
    this.operationFlashOn = false;
    this.show = true;
  }

  public toJson() {
    return [
      {
        type: FlashTypes.torchOn,
        duration: Math.round(this.duration) / 1000,
        time: Math.round(this.position),
        sectionList: this.sectionList && this.sectionList.length > 0 ? this.sectionList : null
      }
    ];
  }
  public tick(state: LightshowState) {
    state.isFlashOn = true;
    this.operationFlashOn = true;
    state.brightness = 1;
  }
  public end(state: LightshowState) {
    state.isFlashOn = false;
    this.operationFlashOn = false;
  }
  public wait () {}
}
